import moment from "moment";
import { Searcher } from "../interfaces";
import { capitalizeString } from "../shared/util";

export class SearchersAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get contact_name() {
        return capitalizeString(this.value.contact_name || '');
    }

    get contact_email() {
        return this.value.contact_email || '';
    }
  
    get update_date() {
        return moment(this.value.update_date).format("YYYY-MM-DD");
    }
    get created_at() {
        return moment(this.value.created_at).format("YYYY-MM-DD");
    }

    get current_date() {
        return moment(this.value.current_date).format("YYYY-MM-DD");
    }

    get issue_date() {
        return moment(this.value.issue_date).format("YYYY-MM-DD");
    }

    get updated_at() {
        return moment(this.value.updated_at).format("YYYY-MM-DD");
    }

    adapt(): Searcher {
        return {
            id: this.value.id,
            description : this.value.description,
            features : this.value.features,
            nme_niv_form_pr : this.value.nme_niv_form_pr,
            nombre :  capitalizeString(this.value.nombre || ''),
            contact_name: this.contact_name,
            contact_email: this.contact_email,
            phone: this.value.phone,
            nme_clasificacion_pr: capitalizeString(this.value.nme_clasificacion_pr || ''),
            nme_municipio_res_pr: capitalizeString(this.value.nme_municipio_res_pr || ''),
            nme_gran_area_pr: capitalizeString(this.value.nme_gran_area_pr?.GRAN_AREA_DE_CONOCIMIENTO || ''),
            nme_area_pr: capitalizeString(this.value.nme_area_pr?.AREA_DE_CONOCIMIENTO || ''),
            nme_esp_area_pr: capitalizeString(this.value.nme_esp_area_pr?.ESPECIALIDAD_DE_CONOCIMIENTO || ''),
            issue_date :this.issue_date,
            current_date : this.current_date,
            id_institucion :  this.value.id_institucion,
            inst_filia :  this.value.inst_filia,
            id_persona_pr :  this.value.id_persona_pr,
            created_at : this.created_at || '',
            updated_at : this.updated_at || '',
            update_date : this.update_date || '',
            actor_type: this.value.actor_type,
            recognized_min: this.value.recognized_min === 1 ? "Si" : 'No',
            source: this.value.source || '',
            city: capitalizeString(this.value.city || ''),
            enlace_cvlac: this.value.enlace_cvlac || '',
        };
    }
}
